var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1.5,
    width: 53,
    height: 53,
    rx: 26.5,
    fill: "#3E51C8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1.5,
    width: 53,
    height: 53,
    rx: 26.5,
    stroke: "white",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.1 30.2H30.7C31.0117 30.2 31.2729 30.0946 31.4838 29.8837C31.6946 29.6729 31.8 29.4117 31.8 29.1V26.9L34 29.1V22.5L31.8 24.7V22.5C31.8 22.1883 31.6946 21.9271 31.4838 21.7162C31.2729 21.5054 31.0117 21.4 30.7 21.4H24.1C23.7883 21.4 23.5271 21.5054 23.3162 21.7162C23.1054 21.9271 23 22.1883 23 22.5V29.1C23 29.4117 23.1054 29.6729 23.3162 29.8837C23.5271 30.0946 23.7883 30.2 24.1 30.2ZM17.5 39V19.2C17.5 18.595 17.7154 18.0771 18.1463 17.6463C18.5771 17.2154 19.095 17 19.7 17H37.3C37.905 17 38.4229 17.2154 38.8538 17.6463C39.2846 18.0771 39.5 18.595 39.5 19.2V32.4C39.5 33.005 39.2846 33.5229 38.8538 33.9538C38.4229 34.3846 37.905 34.6 37.3 34.6H21.9L17.5 39Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMessage);
export default __webpack_public_path__ + "static/media/icon-message.c808c0116c9db89a7aefd41084be85b7.svg";
export { ForwardRef as ReactComponent };